import React from 'react';
import { useMutation } from '@tanstack/react-query';
import type { IntelSource } from '../../../types/intel-source.js';
import { Toggle } from '../../../components/ui';
import { updateIntelSourceMutation } from '../../../generated/api/@tanstack/react-query.gen.js';
import { useIntelSourceInvalidation } from './intel-source-queries.js';

/** Active switch for a DataTable row (demo /tables/data-tables row controls). Applies immediately. */
interface ActiveToggleCellProps {
  source: IntelSource;
  canManage: boolean;
}

export const ActiveToggleCell: React.FC<ActiveToggleCellProps> = ({ source, canManage }) => {
  const invalidate = useIntelSourceInvalidation();
  const mut = useMutation({
    ...updateIntelSourceMutation(),
    onSuccess: () => invalidate(source.id),
  });
  return (
    // The row opens the detail on click; the switch must not.
    <span role="presentation" onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
      <Toggle
        checked={source.active}
        disabled={!canManage || mut.isPending}
        aria-label={`${source.active ? 'Deactivate' : 'Activate'} ${source.name ?? source.handle}`}
        onChange={(active) => mut.mutate({ path: { id: source.id }, body: { active } })}
      />
    </span>
  );
};
